if (!customElements.get("product-feed")) {
  customElements.define(
    "product-feed",
    class ProductFeed extends HTMLElement {
      constructor() {
        super();
        this.$selectors = {
          activeFetcher: `[data-active-fetcher="true"]`,
          dataFeedUrls: `[data-feed-urls]`,
          feed: `._feed`,
          feedBlock: `.js-feed-block`,
          feedCrumb: `.js-feed-crumb`,
          sublink: `.js-sublink`,
          emptyCollection: `._emptyCollection`,
          desktopMenu: `.js-desktopMenu`,
          mobileMenu: `.js-mobileMenu`,
          mobileMenuParentLinks: `.js-mobileMenuParentLinks`,
          mobileParentLink: `.js-mobileParentLink`,
          mobileMenuChildLinks: `.js-mobileMenuChildLinks`,
          mobileChildLink: `.js-mobileChildLink`,
          mobileMenuGrandChildLinks: `.js-mobileMenuGrandChildLinks`,
          mobileGrandChildLink: `.js-mobileGrandChildLink`,
          gradientFinish: `.js-gradient-finish`,
        };
        this.gradientFinish = this.querySelector(
          this.$selectors.gradientFinish
        );
        if (this.gradientFinish) {
          this.gradientFinishHTML = this.gradientFinish.outerHTML;
        }

        this.classes = {
          parentLi:
            "",
          defaultSummary:
            "flex items-center w-auto focus:ring-0 gap-4 pr-8 py-2 hover:text-accent1 leading-tight",
          defaultDiv:
            "block w-full overflow-hidden font-normal text-tight-sm pb-2",
          parentSummary: "font-medium",
          childSummary:
            "pl-5 data-[active-fetcher=true]:font-medium data-[active-fetcher=true]:text-accent1",
          simpleParentButton:
            "w-full text-left font-medium data-[active-fetcher=true]:text-accent1",
          childButton:
            "gap-4 flex items-center w-full pl-6 pr-8 py-2 hover:text-accent1 text-left data-[active-fetcher=true]:text-accent1",
          multiFetcherChild:
            "flex items-center gap-4 block pl-8 pr-2 py-2 hover:text-accent1 js-sublink data-[highlighted=true]:text-accent1",
          grandChild:
            "flex items-center gap-4 block pl-5 text-solid-xs ml-6 pr-2 py-1.5 border-l border-accent1/50 hover:text-accent1 js-sublink font-medium data-[highlighted=true]:text-accent1 data-[highlighted=true]:font-medium",
          image: {
            parent: "w-8 h-8 object-cover rounded-sm lazyload",
            child: "w-6 h-6 object-cover rounded-sm border border-outline/10 lazyload",
          },
          mobileParentButton:
            "js-mobileParentLink block p-3 cursor-pointer _parentFetcher whitespace-nowrap hover:bg-background1 hover:text-text data-[active-fetcher=true]:bg-background2 data-[active-fetcher=true]:text-text data-[parent-link-is-active=true]:bg-background2 data-[parent-link-is-active=true]:text-text _mobileParentLink",
          mobileChildButton:
          "js-mobileChildLink relative data-[child-link-is-active=true]:bg-background1 data-[child-link-is-active=true]:text-accent1 font-medium whitespace-nowrap p-3 data-[child-link-is-active=true]:no-underline",
          mobileMultiFetcherChild:
          "js-mobileChildLink js-sublink relative data-[child-link-is-active=true]:bg-accent1 data-[child-link-is-active=true]:text-accent1_fg  rounded-t whitespace-nowrap p-3 data-[child-link-is-active=true]:no-underline",
          mobileGrandChildButton:
            "js-mobileGrandChildLink js-sublink inline-block p-1.5 whitespace-nowrap hidden my-1.5 rounded data-[child-link-is-active=true]:inline-block data-[highlighted=true]:bg-accent1 data-[highlighted=true]:text-accent1_fg",
        };

        // Store cleanup functions
        this._cleanupFunctions = [];
        this._detailsToggleHandlers = new WeakMap();
        this._hoverClickHandlers = new WeakMap();
        this._clickDebounceTimer = null;
        this._isInitializing = false;
        this._isFetching = false;

        if (sessionStorage.getItem("menuData")) {
          window.menuData = JSON.parse(sessionStorage.getItem("menuData"));
        }
        
        // Bind init method and store reference for cleanup
        this._boundInit = this.init.bind(this);
        this.init();
        document.addEventListener("fetched:menuData", this._boundInit);
        this._cleanupFunctions.push(() => {
          document.removeEventListener("fetched:menuData", this._boundInit);
        });
        // document.addEventListener(
        //   "feed-fetcher:fetched",
        //   this.onFeedChange.bind(this)
        // );

        // // when this in view, hide scroll-top
        // this.scrollObserver = new IntersectionObserver((entries) => {
        //   entries.forEach((entry) => {
        //     const scrollTop = document.querySelector("scroll-top");
        //     if (!scrollTop) return;
        //     if (entry.isIntersecting) {
        //       scrollTop.animate([{ left: 1 }, { opacity: 0 }], {
        //         duration: 200,
        //         easing: "ease-in-out",
        //         fill: "forwards",
        //       });
        //     } else {
        //       scrollTop.animate([{ opacity: 0 }, { opacity: 1 }], {
        //         duration: 200,
        //         easing: "ease-in-out",
        //         fill: "forwards",
        //       });
        //     }
        //   });
        // });
        // this.scrollObserver.observe(this);
      }

      init(e) {
        // Prevent multiple simultaneous initializations
        if (this._isInitializing) return;
        this._isInitializing = true;

        // Clean up previous listeners before re-initializing
        this._cleanupEventListeners();

        window.menuData.forEach((menu, parentIndex) => {
          menu.children.forEach((child, index) => {
            // last item is empty strings so remove it
            if (child.titles)
              child.titles = child.titles.split("~").slice(0, -1);
            if (child.counts) {
              child.counts = child.counts.split(",").slice(0, -1);
            } else if (child.count === "") {
              window.menuData[parentIndex].children.splice(index, 1);
            }
            if (child.images)
              child.images = child.images.split(",").slice(0, -1);
            if (child.urls) child.urls = child.urls.split(",").slice(0, -1);
          });
        });
        this.menuData = window.menuData;
        this.renderDesktopMenu();
        this.renderMobileMenu();
        this.renderGrandchildren();
        this.defineFixedNodes();
        this.defineDynamicNodes();
        this.initDesktopMenuAccordions();
        this.listenFetchers();
        setTimeout(() => {
          this.onFeedChange();
          this._isInitializing = false;
        }, 300);
      }

      _cleanupEventListeners() {
        // Execute all cleanup functions
        this._cleanupFunctions.forEach(cleanup => cleanup());
        this._cleanupFunctions = [];
        
        // Clean up hover/click handlers
        if (this.$feedFetchers) {
          this.$feedFetchers.forEach((link) => {
            const cleanup = this._hoverClickHandlers.get(link);
            if (cleanup) cleanup();
          });
        }
        this._hoverClickHandlers = new WeakMap();
        
        // Clean up details toggle handlers
        if (this.$feedFetchers) {
          this.querySelectorAll('details[data-parent-index]').forEach((details) => {
            const handler = this._detailsToggleHandlers.get(details);
            if (handler) {
              details.removeEventListener("toggle", handler);
            }
          });
        }
        this._detailsToggleHandlers = new WeakMap();
        
        // Disconnect observers
        if (this.highlightObserver) {
          this.highlightObserver.disconnect();
          this.highlightObserver = null;
        }

        // Cancel pending debounce timers
        if (this._clickDebounceTimer) {
          clearTimeout(this._clickDebounceTimer);
          this._clickDebounceTimer = null;
        }

        // Cancel pending fetch operations
        if (window.abortControllers?.fetcherHover) {
          window.abortControllers.fetcherHover.abort("Component cleanup");
        }
        if (window.fetchController) {
          window.fetchController.abort("Component cleanup");
        }
      }

      disconnectedCallback() {
        this._cleanupEventListeners();
        if (this._clickDebounceTimer) {
          clearTimeout(this._clickDebounceTimer);
        }
      }
      renderDesktopMenu() {
        const desktopMenu = this.querySelector(this.$selectors.desktopMenu);
        if (this.gradientFinishHTML)
          desktopMenu.innerHTML = this.gradientFinishHTML;

        this.findActiveMenuItems();

        // Render all parents first
        this.menuData.forEach((parent, parentIndex) => {
          const parentLi = this.createParentLi(parent, parentIndex);
          if (parentLi) {
            desktopMenu.appendChild(parentLi);
          }
        });

        // Render all children
        this.menuData.forEach((parent, parentIndex) => {
          if (parent.children.length > 0) {
            const parentDetails = desktopMenu.querySelector(
              `details[data-parent-index="${parentIndex}"]`
            );
            if (parentDetails) {
              const childrenUl = this.createChildrenList(parent, parentIndex);
              const contentDiv = parentDetails.querySelector(
                `div[id="menu-${parentIndex}"]`
              );
              if (contentDiv) {
                contentDiv.appendChild(childrenUl);
              }
            }
          }
        });
      }

      findActiveMenuItems() {
        this.activeParent = this.menuData.find((parent) =>
          parent.children.some((child) => {
            if (child.urls?.length > 0) {
              return child.urls.some(
                (url) => url === window.initiallyActiveLink
              );
            }
          })
        );
        if (!this.activeParent) {
          this.activeParent = this.menuData.find((parent) =>
            parent.children.some(
              (child) => child.url === window.initiallyActiveLink
            )
          );
        }
        if (!this.activeParent) {
          this.activeParent = this.menuData.find(
            (parent) => parent.url === window.initiallyActiveLink
          );
        }

        this.activeChild = this.activeParent.children.find((child) => {
          if (child.urls?.length > 0) {
            return child.urls.some((url) => url === window.initiallyActiveLink);
          }
        });
        if (!this.activeChild) {
          this.activeChild = this.activeParent.children.find(
            (child) => child.url === window.initiallyActiveLink
          );
        }
      }

      createParentLi(parent, parentIndex) {
        const parentLi = document.createElement("li");
        parentLi.className = this.classes.parentLi;

        if (parent.children.length === 0) {
          if (parent.count === "0" || parent.count === "") return null;
          return this.createSimpleParentLink(parent, parentLi, parentIndex);
        }

        const details = this.createParentDetails(parent, parentIndex);
        parentLi.appendChild(details);

        return parentLi;
      }

      createMobileParentButton(parent, parentIndex) {
        const parentButton = document.createElement("button");
        parentButton.setAttribute("tabindex", 0);
        parentButton.className = this.classes.mobileParentButton;
        parentButton.id = `parent-${parent.title
          .replace(/\s/g, "-")
          .toLowerCase()}`;
        parentButton.dataset.index = parentIndex;
        parentButton.dataset.parentLinkIsActive = parent === this.activeParent;
        parentButton.textContent = parent.title;

        return parentButton;
      }

      createMobileChildButton(child, childIndex, parent, parentIndex) {
        if (!child.titles && child.count === "0") return null;

        const childButton = document.createElement("button");
        childButton.dataset.parentLinkIsActive = parent === this.activeParent;
        childButton.dataset.childLinkIsActive = child === this.activeChild;
        childButton.className = this.classes.mobileChildButton;
        // childButton.className += child.titles
        //   ? " data-[child-link-is-active=true]:bg-background2"
        //   : " data-[child-link-is-active=true]:bg-background2";

        childButton.setAttribute("tabindex", 0);
        childButton.dataset.index = parentIndex + "-" + childIndex;
        childButton.dataset.parentId = `parent-${parent.title
          .replace(/\s/g, "-")
          .toLowerCase()}`;
        childButton.dataset.childId = `child-${child.title
          .replace(/\s/g, "-")
          .toLowerCase()}`;
        childButton.textContent = child.title;

        return childButton;
      }

      createMobileGrandChildButton(
        title,
        grandChildIndex,
        child,
        childIndex,
        parent,
        parentIndex
      ) {
        if (child !== this.activeChild) return;
        const grandChildButton = document.createElement("button");
        grandChildButton.dataset.parentLinkIsActive =
          parent == this.activeParent;
        grandChildButton.dataset.childLinkIsActive = child == this.activeChild;
        grandChildButton.className = this.classes.mobileGrandChildButton;
        grandChildButton.setAttribute("tabindex", 0);
        grandChildButton.dataset.index =
          parentIndex + "-" + childIndex + "-" + grandChildIndex;
        grandChildButton.dataset.parentId = `parent-${parent.title
          .replace(/\s/g, "-")
          .toLowerCase()}`;
        grandChildButton.dataset.childId = `child-${child.title
          .replace(/\s/g, "-")
          .toLowerCase()}`;
        grandChildButton.textContent = title;

        return grandChildButton;
      }

      createSimpleParentLink(parent, parentLi, parentIndex) {
        const button = document.createElement("button");
        button.className = `${this.classes.defaultSummary} ${this.classes.simpleParentButton}`;
        button.dataset.feedUrls = parent.url;
        button.dataset.counts = parent.count;
        button.dataset.index = parentIndex;
        button.dataset.activeFetcher = parent == this.activeParent;

        this.appendImageOrPlaceholder(button, parent.image, parent.title);

        const title = document.createElement("span");
        title.textContent = parent.title;
        title.classList.add("w-full");
        button.appendChild(title);

        button.innerHTML += window.icons.chevronRight;
        parentLi.appendChild(button);

        return parentLi;
      }

      createParentDetails(parent, parentIndex) {
        const details = document.createElement("details");
        details.setAttribute("type", "accordion");
        details.dataset.accordionSyncGroup = "parent";
        details.dataset.parentIndex = parentIndex;
        details.className = "block cursor-pointer";
        if (parent == this.activeParent) {
          details.setAttribute("open", "");
        }

        const toggleHandler = (e) => {
          if (e.target.hasAttribute("open")) {
            this.activeParent = parent;
            this.renderGrandchildren();
          }
        };
        details.addEventListener("toggle", toggleHandler);
        this._detailsToggleHandlers.set(details, toggleHandler);

        const summary = this.createSummary(parent, parentIndex);
        details.appendChild(summary);

        const div = document.createElement("div");
        div.id = `menu-${parentIndex}`;
        div.className = this.classes.defaultDiv;
        details.appendChild(div);

        return details;
      }

      createSummary(parent, parentIndex) {
        const summary = document.createElement("summary");
        summary.setAttribute("tabindex", 0);
        summary.setAttribute("aria-controls", `menu-${parentIndex}`);
        summary.dataset.title = parent.title;
        summary.className = `${this.classes.defaultSummary} ${this.classes.parentSummary}`;
        summary.dataset.index = parentIndex;

        this.appendImageOrPlaceholder(summary, parent.image, parent.title);

        const parentTitle = document.createElement("span");
        parentTitle.textContent = parent.title;
        parentTitle.classList.add("w-full");
        summary.appendChild(parentTitle);

        summary.innerHTML += this.getPlusMinusIcon();

        const parentIsAMultiFetcher = !parent.children.some(
          (child) => child.titles
        );
        if (parentIsAMultiFetcher) {
          this.setupMultiFetcher(summary, parent);
        }

        return summary;
      }

      createChildrenList(parent, parentIndex) {
        const ul = document.createElement("ul");
        const parentIsAMultiFetcher = !parent.children.some(
          (child) => child.titles
        );

        parent.children.forEach((child, childIndex) => {
          if (child.count === "0" && child.titles == "") return;

          const li = document.createElement("li");

          if (parentIsAMultiFetcher) {
            this.createMultiFetcherChild(child, childIndex, parentIndex, li);
          } else {
            this.createAccordionChild(child, childIndex, parentIndex, li);
          }

          ul.appendChild(li);
        });

        return ul;
      }
      createMultiFetcherChild(child, childIndex, parentIndex, li) {
        const childA = document.createElement("a");
        childA.href = `#collection-${child.url.split("/collections/")[1]}`;
        childA.className = this.classes.multiFetcherChild;
        childA.dataset.index = parentIndex + "-" + childIndex;

        // this.appendImageOrPlaceholder(
        //   childA,
        //   child.image,
        //   child.title,
        //   this.classes.image.child
        // );

        const childTitle = document.createElement("span");
        childTitle.textContent = child.title;
        childA.appendChild(childTitle);

        li.appendChild(childA);
      }

      createAccordionChild(child, childIndex, parentIndex, li) {
        if (!child.titles) {
          return this.createSingleFetcherChild(
            child,
            childIndex,
            parentIndex,
            li
          );
        }

        const childDetails = document.createElement("details");
        childDetails.setAttribute("type", "accordion");
        childDetails.dataset.accordionSyncGroup = "child";
        childDetails.classList = "block cursor-pointer";
        childDetails.dataset.childIndex = `${parentIndex}-${childIndex}`;
        if (child == this.activeChild) {
          childDetails.setAttribute("open", "");
        }

        const childSummary = this.createChildSummary(
          child,
          parentIndex,
          childIndex
        );
        childDetails.appendChild(childSummary);

        const childDiv = document.createElement("div");
        childDiv.id = `menu-${parentIndex}-${childIndex}`;
        childDiv.classList = this.classes.defaultDiv;
        childDetails.appendChild(childDiv);

        li.appendChild(childDetails);

        return li;
      }

      renderGrandchildren() {
        this.menuData.forEach((parent, parentIndex) => {
          parent.children.forEach((child, childIndex) => {
            if (child.titles) {
              const childDetails = this.querySelector(
                `details[data-child-index="${parentIndex}-${childIndex}"]`
              );
              if (childDetails) {
                const contentDiv = childDetails.querySelector(
                  `div[id="menu-${parentIndex}-${childIndex}"]`
                );
                if (contentDiv) {
                  contentDiv.innerHTML = "";
                  if (parent != this.activeParent) {
                    return;
                  }
                  const grandchildrenUl = this.createGrandchildrenList(
                    child,
                    childIndex,
                    parentIndex
                  );
                  contentDiv.appendChild(grandchildrenUl);
                }
              }
            }
          });
        });
      }

      createSingleFetcherChild(child, childIndex, parentIndex, li) {
        if (child.count === "0") return li;

        const childButton = document.createElement("button");
        childButton.dataset.title = child.title;
        childButton.dataset.feedUrls = child.url;
        childButton.dataset.counts = child.count;
        childButton.className = this.classes.childButton;
        childButton.dataset.activeFetcher = child == this.activeChild;
        childButton.dataset.index = parentIndex + "-" + childIndex;

        if (child == this.activeChild) {
          childButton.classList.add("bg-accent1", "text-accent1_fg");
        }

        // this.appendImageOrPlaceholder(
        //   childButton,
        //   child.image,
        //   child.title,
        //   this.classes.image.child
        // );

        const childTitle = document.createElement("span");
        childTitle.textContent = child.title;
        childTitle.classList.add("w-full");
        childButton.appendChild(childTitle);
        childButton.innerHTML += window.icons.chevronRight;

        li.appendChild(childButton);
        return li;
      }

      createChildSummary(child, parentIndex, childIndex) {
        const childSummary = document.createElement("summary");
        childSummary.setAttribute("tabindex", 0);
        childSummary.setAttribute(
          "aria-controls",
          `menu-${parentIndex}-${childIndex}`
        );
        childSummary.dataset.title = child.title;
        childSummary.className = `${this.classes.defaultSummary} ${this.classes.childSummary}`;
        childSummary.dataset.feedUrls = child.urls;
        childSummary.dataset.counts = child.counts;
        childSummary.dataset.activeFetcher = child == this.activeChild;
        childSummary.dataset.index = parentIndex + "-" + childIndex;

        // this.appendImageOrPlaceholder(
        //   childSummary,
        //   child.image,
        //   child.title,
        //   this.classes.image.child
        // );

        childSummary.innerHTML += this.getPlusMinusIcon();
        const childTitle = document.createElement("span");
        childTitle.textContent = child.title;
        childTitle.classList.add("w-full");
        childSummary.appendChild(childTitle);

        return childSummary;
      }

      createGrandchildrenList(child, childIndex, parentIndex) {
        const childUl = document.createElement("ul");

        if (child.titles && Array.isArray(child.titles)) {
          child.titles.forEach((title, grandChildIndex) => {
            const grandChildLi = document.createElement("li");
            const grandChildA = document.createElement("a");
            grandChildA.href = `#collection-${child.urls[grandChildIndex]
              .split("/collections/")[1]}`;
            grandChildA.className = this.classes.grandChild;
            grandChildA.dataset.index = `${parentIndex}-${childIndex}-${grandChildIndex}`;

            // this.appendImageOrPlaceholder(
            //   grandChildA,
            //   child.images?.[grandChildIndex],
            //   title,
            //   this.classes.image.child
            // );

            const grandChildTitle = document.createElement("span");
            grandChildTitle.textContent = title;
            grandChildA.appendChild(grandChildTitle);

            grandChildLi.appendChild(grandChildA);
            childUl.appendChild(grandChildLi);
          });
        }

        return childUl;
      }

      appendImageOrPlaceholder(
        element,
        imageSrc,
        altText,
        imageClass = this.classes.image.parent
      ) {
        if (!imageSrc) return;
        if (imageSrc?.includes("/")) {
          const image = document.createElement("img");
          image.src = imageSrc;
          image.alt = altText;
          image.className = imageClass;
          element.appendChild(image);
        } else {
          const imagePlaceholder = document.createElement("div");
          imagePlaceholder.className = imageClass
            .replace("object-cover", "")
            .trim();
          element.appendChild(imagePlaceholder);
        }
      }

      getPlusMinusIcon() {
        return window.icons.plusMinusAnimated
          .replace("<line-animation-class>", "[[open]_>_summary_&]:rotate-90")
          .replace(
            "<animation-class>",
            "[[open]_>_summary_&]:rotate-180 opacity-50"
          );
      }

      setupMultiFetcher(el, parent) {
        el.dataset.feedUrls = parent.children
          .map((child) => child.url)
          .join(",");
        el.dataset.counts = parent.children
          .map((child) => child.count)
          .join(",");
        el.dataset.activeFetcher = parent == this.activeParent;
      }
      renderMobileMenu() {
        this.renderMobileParents();
        this.renderMobileChildren();
        this.renderMobileGrandchildren();
        this.addMobileMenuListeners();
      }

      renderMobileParents() {
        const mobileParentContainer = this.querySelector(
          this.$selectors.mobileMenuParentLinks
        );
        mobileParentContainer.innerHTML = ""; // Clear existing content

        this.menuData.forEach((parent, parentIndex) => {
          const mobileParentButton = this.createMobileParentButton(
            parent,
            parentIndex
          );
          mobileParentContainer.appendChild(mobileParentButton);
        });
      }

      renderMobileChildren() {
        const mobileChildContainer = this.querySelector(
          this.$selectors.mobileMenuChildLinks
        );
        mobileChildContainer.innerHTML = ""; // Clear existing content
        mobileChildContainer.scrollTo({ left: 0, behavior: 'smooth' });

        if (this.activeParent) {
          this.activeParent.children.forEach((child, childIndex) => {
            const mobileChildButton = this.createMobileChildButton(
              child,
              childIndex,
              this.activeParent,
              this.menuData.indexOf(this.activeParent)
            );
            if (mobileChildButton) {
              mobileChildContainer.appendChild(mobileChildButton);
            }
          });
        }
      }

      renderMobileGrandchildren() {
        const mobileGrandchildContainer = this.querySelector(
          this.$selectors.mobileMenuGrandChildLinks
        );
        mobileGrandchildContainer.innerHTML = ""; // Clear existing content
        mobileGrandchildContainer.style.opacity = 0;
        mobileGrandchildContainer.scrollTo({ left: 0, behavior: 'smooth' });

        if (this.activeChild && this.activeChild.titles) {
          this.activeChild.titles.forEach((title, grandChildIndex) => {
            const mobileGrandChildButton = this.createMobileGrandChildButton(
              title,
              grandChildIndex,
              this.activeChild,
              this.activeParent.children.indexOf(this.activeChild),
              this.activeParent,
              this.menuData.indexOf(this.activeParent)
            );
            if (mobileGrandChildButton) {
              mobileGrandchildContainer.appendChild(mobileGrandChildButton);
            }
            mobileGrandchildContainer.style.opacity = "";
          });
        }
      }

      addMobileMenuListeners() {
        const parentContainer = this.querySelector(
          this.$selectors.mobileMenuParentLinks
        );
        const childContainer = this.querySelector(
          this.$selectors.mobileMenuChildLinks
        );
        const grandChildContainer = this.querySelector(
          this.$selectors.mobileMenuGrandChildLinks
        );

        // Use event delegation with stored handlers for cleanup
        const parentClickHandler = (e) => {
          const parentButton = e.target.closest("button");
          if (!parentButton) return;

          // Debounce rapid clicks
          if (this._clickDebounceTimer) {
            clearTimeout(this._clickDebounceTimer);
          }
          
          this._clickDebounceTimer = setTimeout(() => {
            const parentIndex = parseInt(parentButton.dataset.index);
            if (isNaN(parentIndex)) return;
            
            this.setActiveParent(parentIndex);
            this.renderMobileChildren();
            this.renderMobileGrandchildren();
            centerInScrollable(parentButton);
            
            // Auto-click first available child
            const firstChildButton = childContainer.querySelector('button[data-index]');
            if (firstChildButton) {
              // Use requestAnimationFrame to ensure DOM is updated
              requestAnimationFrame(() => {
                firstChildButton.click();
              });
            }
            
            // Trigger desktop menu action
            const desktopParentSummary = this.querySelector(
              `${this.$selectors.desktopMenu} summary[data-index="${parentIndex}"]`
            );
            if (desktopParentSummary) {
              desktopParentSummary.click();
            } else {
              const desktopParentButton = this.querySelector(
                `${this.$selectors.desktopMenu} button[data-index="${parentIndex}"]`
              );
              if (desktopParentButton) {
                desktopParentButton.click();
              }
            }
          }, 50); // 50ms debounce
        };

        const childClickHandler = (e) => {
          const childButton = e.target.closest("button");
          if (!childButton) return;

          // Debounce rapid clicks
          if (this._clickDebounceTimer) {
            clearTimeout(this._clickDebounceTimer);
          }
          
          this._clickDebounceTimer = setTimeout(() => {
            const indexParts = childButton.dataset.index?.split("-");
            if (!indexParts || indexParts.length < 2) return;
            
            const [parentIndex, childIndex] = indexParts.map(Number);
            if (isNaN(parentIndex) || isNaN(childIndex)) return;
            
            this.setActiveChild(parentIndex, childIndex);
            this.renderMobileGrandchildren();
            centerInScrollable(childButton);

            // Trigger desktop menu action
            const desktopChildElement = this.querySelector(
              `${this.$selectors.desktopMenu} [data-index="${parentIndex}-${childIndex}"]`
            );
            if (desktopChildElement) {
              desktopChildElement.click();
            }
          }, 50); // 50ms debounce
        };

        const grandChildClickHandler = (e) => {
          const grandChildButton = e.target.closest("button");
          if (!grandChildButton) return;

          // Debounce rapid clicks
          if (this._clickDebounceTimer) {
            clearTimeout(this._clickDebounceTimer);
          }
          
          this._clickDebounceTimer = setTimeout(() => {
            const indexParts = grandChildButton.dataset.index?.split("-");
            if (!indexParts || indexParts.length < 3) return;
            
            const [parentIndex, childIndex, grandChildIndex] = indexParts.map(Number);
            if (isNaN(parentIndex) || isNaN(childIndex) || isNaN(grandChildIndex)) return;

            // Trigger desktop menu action
            const desktopGrandChildElement = this.querySelector(
              `${this.$selectors.desktopMenu} a[data-index="${parentIndex}-${childIndex}-${grandChildIndex}"]`
            );
            if (desktopGrandChildElement) {
              desktopGrandChildElement.click();
            }
          }, 50); // 50ms debounce
        };

        parentContainer.addEventListener("click", parentClickHandler);
        childContainer.addEventListener("click", childClickHandler);
        grandChildContainer.addEventListener("click", grandChildClickHandler);

        // Store handlers for cleanup
        this._cleanupFunctions.push(() => {
          parentContainer.removeEventListener("click", parentClickHandler);
          childContainer.removeEventListener("click", childClickHandler);
          grandChildContainer.removeEventListener("click", grandChildClickHandler);
        });
      }

      setActiveParent(parentIndex) {
        this.activeParent = this.menuData[parentIndex];
        this.activeChild = null;
        this.querySelectorAll(this.$selectors.mobileParentLink).forEach(
          (button) => {
            button.dataset.parentLinkIsActive =
              button.dataset.index === parentIndex.toString();
          }
        );
      }

      setActiveChild(parentIndex, childIndex) {
        this.activeParent = this.menuData[parentIndex];
        this.activeChild = this.activeParent.children[childIndex];
        this.querySelectorAll(this.$selectors.mobileChildLink).forEach(
          (button) => {
            button.dataset.childLinkIsActive =
              button.dataset.index === `${parentIndex}-${childIndex}`;
          }
        );
      }

      initDesktopMenuAccordions() {
        this.querySelectorAll('details[type="accordion"]').forEach((el) => {
          new Accordion(el);
        });
      }

      defineFixedNodes() {
        this.$feed = this.querySelector(this.$selectors.feed);
        this.$feedFetchers = this.querySelectorAll(
          this.$selectors.dataFeedUrls
        );
        this.$mobileParentLinks = this.querySelectorAll(
          this.$selectors.mobileParentLink
        );
        this.$mobileChildLinks = this.querySelectorAll(
          this.$selectors.mobileChildLink
        );
        this.$mobileGrandChildLinks = this.querySelectorAll(
          this.$selectors.mobileGrandChildLink
        );
      }

      listenFetchers() {
        // Clean up old handlers first
        this.$feedFetchers.forEach((link) => {
          const oldCleanup = this._hoverClickHandlers.get(link);
          if (oldCleanup) {
            oldCleanup();
          }
        });

        // Add new handlers
        this.$feedFetchers.forEach((link) => {
          const cleanup = hoverClickBusHandler(
            link,
            (link) => this.onFetcherHover(link),
            (link) => this.onFetcherClick(link),
            (link) => this.onFetcherFetch(link),
            100
          );
          this._hoverClickHandlers.set(link, cleanup);
        });
      }

      defineDynamicNodes() {
        this.$activeFetcher = this.querySelector(this.$selectors.activeFetcher);
        this.$feedBlocks = this.querySelectorAll(this.$selectors.feedBlock);
        this.$feedCrumbs = this.querySelectorAll(this.$selectors.feedCrumb);
        this.$sublinks = this.querySelectorAll(this.$selectors.sublink);
        this.activeParentLinkTitle =
          [...this.$mobileParentLinks].find(
            (parentLink) => parentLink.dataset.parentLinkIsActive === "true"
          )?.dataset.title || "";
        this.activeChildLinkTitle =
          [...this.$mobileChildLinks].find(
            (childLink) => childLink.dataset.childLinkIsActive === "true"
          )?.dataset.title || "";
      }

      cacheFeed() {
        window.feeds = window.feeds || {};
        window.feeds[this.$activeFetcher.dataset.feedUrls] =
          this.$feed.innerHTML;
      }

      initHighlights() {
        this.$feedBlocks.forEach((block) => {
          // add data-index to each feed block for highlighter per hash sublink match
          const sublink = [...this.$sublinks].find(
            (sublink) =>
              sublink.hash === `#${block.id}` &&
              sublink.closest('details[open]') // if has async group child, shouldn't be false, if it doesn't have sync group child, its fine as it should be multifetcher child
          );
          if (sublink) block.dataset.index = sublink.dataset.index;
        });

        // manage sublink highlighters on scroll down
        let visibleItems = [];

        const callback = (entries) => {
          entries.forEach((entry) => {
            const index = entry.target.dataset.index;

            /* SET TO BE HIGHLIGHTED ARRAY */
            if (entry.isIntersecting && !visibleItems.includes(index)) {
              // add if intersecting and not already in
              visibleItems.push(index);
            } else if (!entry.isIntersecting && visibleItems.includes(index)) {
              // remove if not intersecting but in
              visibleItems.splice(visibleItems.indexOf(index), 1);
            }

            // return if nothing's left in the array
            if (visibleItems.length === 0) return;

            // sort visibleItems array by their indexes in feedBlocks
            visibleItems.sort((a, b) => {
              return (
                [...this.$feedBlocks].findIndex(
                  (block) => block.dataset.index === a
                ) -
                [...this.$feedBlocks].findIndex(
                  (block) => block.dataset.index === b
                )
              );
            });

            // reset all highlights
            this.$sublinks.forEach(
              (sublink) => (sublink.dataset.highlighted = false)
            );

            // Determine which item to highlight when scrolling
            const highlightIndex =
              visibleItems.length >= 2 && !isAnchorLinkScroll ? 1 : 0;

            this.$sublinks.forEach((sublink, index) => {
              let initially = sublink.dataset.highlighted;
              sublink.dataset.highlighted =
                sublink.dataset.index === visibleItems[highlightIndex];
              let after = sublink.dataset.highlighted;
              if (initially !== after && after === "true") {
                // if the sublink is mobile, scroll to it
                if (sublink.closest(this.$selectors.mobileMenu)) {
                  centerInScrollable(sublink);
                }
              }
            });
          });
        };

        // bottom should be half of viewport height
        if (this.highlightObserver) this.highlightObserver.disconnect();
        this.highlightObserver = new IntersectionObserver(callback, {
          rootMargin: `-20% 0px -${window.innerHeight / 2}px 0px`,
        });
        this.$feedBlocks.forEach((block) => {
          this.highlightObserver.observe(block);
        });
      }

      onFeedChange() {
        this.defineDynamicNodes();
        this.initHighlights();
        this.renderBreadcrumbs();
        triggerEvent(document, "dom:manipulated");
      }

      renderBreadcrumbs() {
        this.$feed.querySelectorAll("[data-feed-title]").forEach((item) => {
          let breadcrumb = "";
          if (this.activeParentLinkTitle != "") {
            breadcrumb += `
              <span class="hidden md:inline-block">
                ${this.activeParentLinkTitle}
              </span>
              <span class="hidden md:inline-block">
                ${window.icons.chevronRight}
              </span>
            `;
          }
          if (this.activeChildLinkTitle != "") {
            breadcrumb += `
              <span>
                ${this.activeChildLinkTitle}
              </span>
              <span>
                ${window.icons.chevronRight}
              </span>
            `;
          }
          breadcrumb += item.dataset.feedTitle;
          item.innerHTML = breadcrumb;
        });
      }

      async onFetcherHover(hoveredFetcher) {
        // do nothing if active link is clicked
        if (hoveredFetcher === this.$activeFetcher) return;

        // define feeds if not, and stop if already cached
        window.feeds = window.feeds || {};
        if (window.feeds[hoveredFetcher.dataset.feedUrls]) return;

        // define abort controllers list if not
        window.abortControllers = window.abortControllers || {};

        // define feedUrls array and empty feedHTMLs
        const feedUrls = hoveredFetcher.dataset.feedUrls.split(",");
        let feedHTMLs = "";

        // abort if any fetcherHover is already running
        window.abortControllers.fetcherHover?.abort(
          "Hover fetch cancelled by new hover request"
        );
        window.abortControllers.fetcherHover = new AbortController();
        const { signal } = window.abortControllers.fetcherHover;

        let fetchFeedPromises = [];
        let feedFetchers = [];
        feedUrls.forEach(async (url, index) => {
          if (index > 1) {
            const div = document.createElement("div");
            div.innerHTML = window.skeletons.feedFetcher;
            const feedFetcher = div.firstElementChild;
            // id is collection-handle
            feedFetcher.id = `collection-${url.split("/collections/")[1]}`;
            feedFetcher.dataset.url = url;
            const counts = parseInt(
              hoveredFetcher.dataset.counts.split(",")[index]
            );
            feedFetcher.dataset.skeletonItems =
              counts > window.settings.product_feed_limit
                ? window.settings.product_feed_limit
                : counts;
            feedFetcher.dataset.onload = true;
            feedFetchers.push(feedFetcher);
            return;
          }
          fetchFeedPromises.push(this.fetchFeed(url, signal));
        });

        const allPromises = await Promise.all(fetchFeedPromises);
        const htmlObject = allPromises.concat(feedFetchers);

        window.feeds[hoveredFetcher.dataset.feedUrls] = htmlObject
          .map((html) => html.outerHTML)
          .join("");
      }

      async onFetcherClick(clickedFetcher) {
        // do nothing if active link is clicked
        if (clickedFetcher === this.$activeFetcher) return;

        await this.$feed.querySelector('.grid').animate([{ opacity: 1 }, { opacity: 0 }], {
          duration: 150,
          fill: "forwards",
        }).finished;

        // cache current feed
        this.cacheFeed();
      }

      async onFetcherFetch(clickedFetcher) {
        // do nothing if active link is clicked
        if (clickedFetcher === this.$activeFetcher) return;

        // Prevent multiple simultaneous fetch operations
        if (this._isFetching) {
          // Cancel previous fetch
          window.fetchController?.abort("Fetch cancelled by new fetch request");
        }
        this._isFetching = true;

        try {
          // if an another fetchFeed function is running in the background, abort it
          window.fetchController?.abort("Fetch cancelled by new fetch request");

          // reset activeFetcher
          this.$feedFetchers.forEach((fetcher) => {
            fetcher.dataset.activeFetcher = fetcher === clickedFetcher;
          });

          // reset parent link is active states
          this.querySelectorAll(
            `${this.$selectors.desktopMenu} [data-parent-link-is-active]`
          ).forEach((item) => {
            item.dataset.parentLinkIsActive = false;
          });

          // reset child link is active states
          this.querySelectorAll(
            `${this.$selectors.desktopMenu} [data-child-link-is-active]`
          ).forEach((item) => {
            item.dataset.childLinkIsActive = false;
          });

          this.querySelectorAll(this.$selectors.activeFetcher).forEach((item) => {
            const parent = item.closest(
              `${this.$selectors.desktopMenu} [data-parent-link-is-active]`
            );
            if (parent) parent.dataset.parentLinkIsActive = true;
          });

          // set activefetcher
          this.$activeFetcher = this.querySelector(this.$selectors.activeFetcher);

          await waitForScrollToEnd();
          // load feed
          const feedUrls = clickedFetcher.dataset.feedUrls.split(",");
          // promise all feedurls with function below
          if (window.feeds && window.feeds[clickedFetcher.dataset.feedUrls]) {
            // scroll viewport to top of the feed
            this.scrollIntoView({ behavior: "instant", block: "start" });
            this.$feed.innerHTML = window.feeds[clickedFetcher.dataset.feedUrls];
            const grid = this.$feed.querySelector('.grid');
            if (grid) {
              await grid.animate([{ opacity: 0 }, { opacity: 1 }], {
                duration: 150,
                fill: "forwards",
              }).finished;
            }
            this.onFeedChange();
            return;
          }
        } catch (error) {
          // Ignore abort errors
          if (error.name !== 'AbortError') {
            console.error("Error in onFetcherFetch:", error);
          }
        } finally {
          this._isFetching = false;
        }
      }

      async fetchFeed(url, signal, params) {
        const fetchUrl = `${url}?section_id=api--product-feed--feed-block${
          params ? `&${params}` : ""
        }`;

        // window.fetchStarted = new Date().getTime();
        // console.log("fetch started", window.fetchStarted);
        // if (window.clicked) {
        //   console.log(
        //     "timebetweenclickandfetch",
        //     window.fetchStarted - window.clicked
        //   );
        // }
        // if (window.hovered) {
        //   console.log(
        //     "timebetweenhoverandfetch",
        //     window.fetchStarted - window.hovered
        //   );
        // }

        const feedHTML = await fetch(fetchUrl, {
          signal,
        })
          .then((response) => {
            if (!response.ok) {
              var error = new Error(response);
              throw error;
            }
            return response.text();
          })
          .then(async (html) => {
            const parsed = await preloadImages(html);
            let feed = parsed.querySelector(this.$selectors.feedBlock);
            if (!feed) {
              feed = parsed.querySelector(this.$selectors.emptyCollection);
            } else if (this.querySelector(this.$selectors.fetcherListMobile)) {
            }
            return feed;
          });
        return feedHTML;
      }
    }
  );
}

function hoverClickBusHandler(
  element,
  hoverCallback,
  beforeClickCallback,
  clickCallback,
  hoverTime = 100
) {
  let hoverPromise = null;
  let hoverTimer = null;
  let isHoverPending = false;

  function startHover(event) {
    if (!hoverPromise && !isHoverPending) {
      // window.hovered = new Date().getTime();
      // console.log("Starting hover callback", hovered);
      isHoverPending = true;
      hoverPromise = hoverCallback(element, event)
        .then((result) => {
          // window.hovercomplete = new Date().getTime();
          // console.log("Hover callback completed", hovercomplete - hovered);
          hoverPromise = null;
          isHoverPending = false;
          return result;
        })
        .catch((error) => {
          // Only log if not aborted
          if (error.name !== 'AbortError') {
            console.error("Hover callback error:", error);
          }
          hoverPromise = null;
          isHoverPending = false;
          throw error;
        });
    }
    return hoverPromise;
  }

  const mousemoveHandler = (event) => {
    clearTimeout(hoverTimer);
    if (!isHoverPending && !hoverPromise) {
      hoverTimer = setTimeout(() => startHover(event), hoverTime);
    }
  };

  const mouseleaveHandler = () => {
    clearTimeout(hoverTimer);
    isHoverPending = false;
    hoverPromise = null;
  };

  const clickHandler = async (event) => {
    // window.clicked = new Date().getTime();
    // console.log("Click event detected", clicked);
    clearTimeout(hoverTimer);

    if (!hoverPromise && !isHoverPending) {
      // console.log("Click before hover, forcing hover start");
      hoverPromise = startHover(event);
    } else {
      // console.log(
      //   "Click during hover or pending hover, waiting for completion"
      // );
      // console.log("Hover promise:", new Date().getTime());
      if (isHoverPending && !hoverPromise) {
        hoverPromise = startHover(event);
      }
    }

    try {
      beforeClickCallback(element, event);
      const hoverResult = await hoverPromise;
      clickCallback(element, event, hoverResult);
    } catch (error) {
      // Only log if not aborted
      if (error.name !== 'AbortError') {
        console.error("Error in hover or click handling:", error);
      }
    }
  };

  element.addEventListener("mousemove", mousemoveHandler);
  element.addEventListener("mouseleave", mouseleaveHandler);
  element.addEventListener("click", clickHandler);

  // Return cleanup function
  return () => {
    clearTimeout(hoverTimer);
    element.removeEventListener("mousemove", mousemoveHandler);
    element.removeEventListener("mouseleave", mouseleaveHandler);
    element.removeEventListener("click", clickHandler);
    hoverPromise = null;
    isHoverPending = false;
  };
}

async function preloadImages(html) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const images = doc.querySelectorAll("img");

  const preloadPromises = Array.from(images).map((img) => {
    return new Promise((resolve, reject) => {
      const newImg = new Image();
      newImg.onload = () => {
        img.src = newImg.src; // Update the src in the parsed HTML
        resolve();
      };
      newImg.onerror = reject;
      newImg.src = img.src;
    });
  });

  await Promise.all(preloadPromises);
  return doc;
}
